import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface CircularProgressWithLabelProps {
  value?: number;
  label?: string;
}

function CircularProgressWithLabel({ value, label }: CircularProgressWithLabelProps) {
  const showProgress = value !== undefined;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          ...(label
            ? {
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                borderRadius: '16px',
                padding: '32px 40px',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
              }
            : {}),
        }}
      >
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
          <CircularProgress
            variant="determinate"
            value={100}
            size={100}
            thickness={4.5}
            sx={{ color: 'rgba(165, 42, 42, 0.15)', position: 'absolute' }}
          />
          <CircularProgress
            variant={showProgress ? 'determinate' : 'indeterminate'}
            value={showProgress ? value : undefined}
            size={100}
            thickness={4.5}
            sx={{ color: 'rgb(165, 42, 42)' }}
          />
          {Boolean(showProgress) && (
            <Box
              sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography
                variant="h6"
                component="div"
                sx={{ fontSize: '18px', fontWeight: 'bold', color: 'rgb(165, 42, 42)' }}
              >
                {`${Math.round(value || 0)}%`}
              </Typography>
            </Box>
          )}
        </Box>

        {label ? (
          <Typography variant="body2" sx={{ mt: 2, fontSize: '14px', color: '#555', fontWeight: 500 }}>
            {label}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
}

export default CircularProgressWithLabel;
